// Sorts the plugins for the Plugins page. A person saw 90 cards in one flat list and could not tell what to switch on first (2026-10-07).

export const ENGINE = [
  'document',
  'renderer',
  'camera',
  'selection',
  'shape-defs',
  'toolbar',
  'commands',
  'context-menu',
  'assets',
  'layout',
  'tool-select',
  'tool-shape',
  'text',
  'persistence-local',
  'main-menu',
  'undo',
  'style-bar',
  'plugin-helper',
].map((s) => 'omni.' + s)

export const GROUPS = [
  {
    id: 'browse',
    name: 'Goal 1 · Keep what you browse',
    level: '',
    blurb: 'Pages, videos and files you bring onto the board.',
    ids: [
      'browser',
      'browser-downloads',
      'embed',
      'web-notes',
      'video-graph',
      'files',
      'file-library',
      'source-groups',
      'links',
      'pin-string',
      'ai-capture',
      'talk-map',
      'word-help',
    ],
  },
  {
    id: 'graph',
    name: 'Goal 1 · See it as a graph',
    level: '',
    blurb: 'Shapes, pens, notes and tidy layouts.',
    ids: [
      'tool-pen',
      'draw-extras',
      'rich-text',
      'text-marker',
      'connectors',
      'quick-connect',
      'shape-library',
      'icon-library',
      'images',
      'sketchy',
      'eyedropper',
      'clipboard',
      'frames',
      'groups',
      'collapse',
      'arrange',
      'arrange-extras',
      'grid-snap',
      'clones',
      'tables',
      'table-layout',
      'export',
      'tabs',
      'split-view',
      'templates',
      'board-skins',
      'smart-layout',
    ],
  },
  {
    id: 'find',
    name: 'Goal 1 · Find it again',
    level: '',
    blurb: 'Zoom, search, maps of the board and views.',
    ids: [
      'find',
      'frame-hints',
      'card-levels',
      'follow',
      'minimap',
      'pan-bounds',
      'zoom-lod',
      'zoom-summary',
      'view-modes',
      'onboarding',
      'shortcuts-help',
      'changelog',
      'meaning-index',
      'media-notes',
    ],
  },
  {
    id: 'ai',
    name: 'Goal 1 · AI helper',
    level: '',
    blurb: 'Ask the AI to map, explain and quiz.',
    ids: [
      'ai',
      'ai-core',
      'ai-tools',
      'ai-jobs',
      'ai-chrome',
      'ai-transformers-js',
      'ai-frame',
      'ai-steps',
      'chat-board',
      'prompt-suggest',
      'mcp-bridge',
      'diagram-code',
    ],
  },
  {
    id: 'team',
    name: 'Goal 1 · Work together',
    level: '',
    blurb: 'Edit live with others, comment and call.',
    ids: ['sync', 'auth', 'presence', 'share', 'calls', 'comments', 'team-chat', 'chat-files'],
  },
  {
    id: 'work',
    name: 'Goal 1 · Board tools',
    level: '',
    blurb: 'Eraser and camera helpers.',
    ids: ['tool-eraser', 'camera-extras'],
  },
  {
    id: 'learn',
    name: 'Goal 2 · Learn and apply (later)',
    level: '',
    blurb: 'Cards, paths and learning on the board.',
    ids: ['ai-learn', 'flashcards', 'bloom-path', 'concept-dots', 'recall'],
  },
  {
    id: 'present',
    name: 'Goal 3 · Explore and present (later)',
    level: '',
    blurb: 'Apps, dashboards, charts and slides.',
    ids: ['live-apps', 'infographics', 'dashboards', 'charts', 'slides'],
  },
  {
    id: 'design',
    name: 'Goal 4 · Manage projects and design (later)',
    level: '',
    blurb: 'Tasks, boards, calendar, wireframes and SVG.',
    ids: ['kanban', 'calendar', 'tasks', 'wireframe', 'svg-paste'],
  },
  {
    id: 'floor',
    name: 'Not in a goal · Team Floor (abandoned)',
    level: '',
    blurb: 'Old office feature, not used.',
    ids: ['office'],
  },
  { id: 'dev', name: 'For developers', level: '', blurb: 'Logs and example plugins.', ids: ['dev-logs', 'hello', 'plugin-wake'] },
].map((g) => ({ ...g, ids: g.ids.map((s) => 'omni.' + s) }))

export const ENGINE_GROUP = {
  id: 'engine',
  name: 'Engine parts',
  level: '',
  blurb: 'Always on. Everything else is built on them.',
  ids: ENGINE,
}

export const OTHER_GROUP = { id: 'other', name: 'Other', level: '', blurb: 'Plugins added from outside.', ids: [] }

export const START_SETS = [
  {
    id: 'draw',
    name: 'Just draw',
    blurb: 'Pens, notes, arrows and pictures.',
    ids: ['tool-pen', 'connectors', 'shape-library', 'images', 'arrange', 'clipboard', 'tool-eraser'],
  },
  {
    id: 'study',
    name: 'Study with AI',
    blurb: 'Read a page or video, let the AI map it and quiz you.',
    ids: [
      'ai',
      'ai-core',
      'ai-learn',
      'ai-capture',
      'ai-frame',
      'flashcards',
      'recall',
      'web-notes',
      'video-graph',
      'browser',
      'embed',
      'files',
      'concept-dots',
      'diagram-code',
    ],
  },
  {
    id: 'team',
    name: 'Team meeting',
    blurb: 'Edit live together, comment and plan.',
    ids: ['sync', 'auth', 'presence', 'comments', 'office', 'kanban', 'calendar', 'changelog'],
  },
  { id: 'present', name: 'Make slides', blurb: 'Slides, charts and export.', ids: ['slides', 'charts', 'export', 'frames'] },
].map((s) => ({ ...s, ids: s.ids.map((x) => 'omni.' + x) }))

export function groupOf(id) {
  if (ENGINE.includes(id)) return ENGINE_GROUP
  for (const group of GROUPS) {
    if (group.ids.includes(id)) return group
  }
  return OTHER_GROUP
}

export function isEngine(id) {
  return ENGINE.includes(id)
}
